export type EducationContactTelemetryEvent =
  | "tc_contact_cta_impression"
  | "tc_contact_cta_clicked"
  | "tc_contact_unavailable_shown";

export type EducationContactType = "phone" | "email" | "website";

export type EducationContactPlacement = "provider_detail_top";

export type EducationContactTelemetryMetadata = {
  slugRequested: string;
  slugCanonicalFromHeader?: string | null;
  centreId?: string | null;
  contactType?: EducationContactType;
  sessionId?: string;
  locale: string;
  isClaimed?: boolean | null;
  hasPhoneCta: boolean;
  hasEmailCta: boolean;
  hasWebsiteCta: boolean;
  placement: EducationContactPlacement;
};

export type EducationContactTelemetryPayload = {
  eventType: EducationContactTelemetryEvent;
  occurredAtUtc?: string;
  metadata?: Record<string, string | number | boolean | null | undefined>;
};

function normalizeMetadata(metadata?: Record<string, string | number | boolean | null | undefined>) {
  if (!metadata) {
    return undefined;
  }

  return Object.fromEntries(
    Object.entries(metadata)
      .filter(([, value]) => value !== undefined)
      .map(([key, value]) => [key, value === null ? null : String(value)])
  );
}

export async function trackEducationContactEvent(
  eventType: EducationContactTelemetryEvent,
  metadata: EducationContactTelemetryMetadata
) {
  try {
    await fetch("/api/education/telemetry", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      keepalive: true,
      body: JSON.stringify({
        eventType,
        occurredAtUtc: new Date().toISOString(),
        metadata: normalizeMetadata(metadata),
      } satisfies EducationContactTelemetryPayload),
    });
  } catch {
    // Best-effort telemetry only.
  }
}
